import { RootState } from '../../store';
import { createSelector } from '@reduxjs/toolkit';

const DeveloperReducer = (state: RootState): RootState['DeveloperReducer'] => state.DeveloperReducer;
const selectDeveloperState = createSelector([DeveloperReducer], (state) => state);

export const selectAccessKeys = createSelector([selectDeveloperState], (state) => state.accessKeys);

export const selectIsLoading = createSelector([selectDeveloperState], (state) => state.isLoading);